import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import {
  ButtonReadMoreCancel,
  ButtonRegister,
  CloseModalReadMore,
  ContainRegister,
  ContentModalReadMore,
  DateEvent,
  HeaderDetail,
  ImgUsa,
  ImgSpain,
  OtherEvent,
  TextModalReadMore,
  TitleAbout,
  TitleOfDetail,
  TitleOtherEvent,
  TitleRegister,
  ButtonCancel,
  MeetingLink,
  useStyles,
} from "./DetailEvent.styled";
import { IconButton, Tooltip } from "@material-ui/core";
import PortalModal from "../../Portals";
import { ReactComponent as CloseIcon } from "../../themes/Icons/close_icon.svg";
import ListOfSpeakers from "../ListOfSpeakers/ListOfSpeakers";
import events from "../../assets/mocks/events.json";
import ListCardEvents from "../ListCardEvents";
import UsaIcon from "../../assets/usa.png";
import SpainIcon from "../../assets/spain.png";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import { getFile } from "../../services/FileManager";
import eventPhoto from "../../assets/image-not-available.png";
import BackButtonComponent from "../BackButtonComponent/BackButtonComponent";
import StarRoundedIcon from "@material-ui/icons/StarRounded";
import FeedbackComponent from "../FeedbackComponent/FeedbackComponent";
import moment from "moment";
import { getStateLoginComplete } from "../../containers/LayoutHome/stateLogin";
import { theme as themeConfig } from "../../themes/themes";

const DetailEvent = ({
  detailEvent,
  buttonRegister,
  buttonAccept,
  buttonCancel,
  buttonDecline,
  buttonSpeaker,
  goToBackPage,
  saveAccept,
  saveRegister,
  saveCancel,
  saveDecline,
  backgroundSpeaker,
  activeSave,
  setActiveSave,
  activeCancel,
  setActiveCancel,
  saveFeedback,
  user,
}) => {
  const longSpeakers = detailEvent?.speakers?.length;
  const longOtherEvents = events.events?.length;
  const classes = useStyles({
    backgroundSpeaker,
    longSpeakers,
    longOtherEvents,
  });
  const [openReadMoreModal, setOpenReadMoreModal] = useState(null);
  const [previewImage, setPreviewImage] = useState();
  const [arrayImageRating, setArrImageRating] = useState([]);
  const [eventRating, setEventRating] = useState(0);
  const [showFeedback, setShowFeedback] = useState(false);
  const [isEventCompleted, setIsEventCompleted] = useState(false);
  const eventDate = detailEvent?.endDate;
  const [userComplete] = useState(getStateLoginComplete());

  useEffect(() => {
    setRatingWidget();
  }, [eventRating]);

  const handleRatingClick = (e) => {
    if (!showFeedback) setShowFeedback(true);
    setEventRating(e?.id ? e.id : e?.currentTarget?.id);
  };

  const handleSendFeedback = (comments) => {
    saveFeedback(detailEvent.idEvent, comments, parseInt(eventRating));
    setShowFeedback(false);
  };

  const getCurrentDateTime = () => {
    const today = new Date();
    const date = new Date(
      Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate())
    );
    return moment(date).format("YYYY-MM-DD");
  };

  const compareDates = () => {
    setIsEventCompleted(
      moment(eventDate?.split("T")[0]).utc().isSameOrAfter(getCurrentDateTime())
    );
  };
  useEffect(() => {
    compareDates();
  }, [eventDate]);

  useEffect(() => {
    if (detailEvent?.photoRegister && detailEvent?.idCategory !== 1) {
      getFile(detailEvent?.photoRegister).then((response) => {
        if (response && response.type !== "archivo-noexistente/json") {
          setPreviewImage(URL.createObjectURL(response));
        }
      });
    } else {
      setPreviewImage(
        detailEvent?.idCategory === 1 ? detailEvent?.photoRegister : eventPhoto
      );
    }
  }, [detailEvent?.photoRegister]);

  useEffect(() => {
    if (detailEvent?.status) {
      if (detailEvent?.status === "Unconfirmed") {
        setActiveSave(true);
      } else {
        setActiveSave(false);
      }
      if (detailEvent?.status === "Accept") {
        setActiveCancel(true);
      } else {
        setActiveCancel(false);
      }
    } else {
      setActiveSave(true);
      setActiveCancel(false);
    }
    setRatingWidget();
  }, [detailEvent]);

  const setRatingWidget = () => {
    let arrRating = [];
    arrRating = [1, 2, 3, 4, 5].map((data, i) => {
      return (
        <StarRoundedIcon
          key={data}
          id={data}
          className="icon-selected-Survey-answer ImageRating"
          style={{
            fill:
              eventRating === 0
                ? "#b7b7b7"
                : eventRating >= data
                ? "#ffc502"
                : "#b7b7b7",
            cursor: "pointer",
          }}
          onClick={handleRatingClick}
        ></StarRoundedIcon>
      );
    });
    setArrImageRating([...arrRating].reverse());
  };

  const showReadMoreModal = () => {
    return openReadMoreModal ? (
      <PortalModal>
        <ContentModalReadMore>
          <CloseModalReadMore>
            <span style={{ marginLeft: "0.2em" }}>
              {openReadMoreModal.nameSpeaker}
            </span>
            <Tooltip title="close">
              <IconButton onClick={() => setOpenReadMoreModal(null)}>
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </CloseModalReadMore>
          <TextModalReadMore>
            <p>{openReadMoreModal.descriptionSpeaker}</p>
            <p
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <MailOutlineIcon
                style={{ width: "0.8em", marginRight: "0.2em" }}
              />{" "}
              {openReadMoreModal.emailSpeaker}
            </p>
          </TextModalReadMore>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              width: "175%",
            }}
          >
            <ButtonReadMoreCancel onClick={() => setOpenReadMoreModal(null)}>
              Close
            </ButtonReadMoreCancel>
          </div>
        </ContentModalReadMore>
      </PortalModal>
    ) : null;
  };

  return (
    <>
      <BackButtonComponent
        backtitle={"Event Manager"}
        locationtitle={detailEvent?.aboutTitleEvent}
        goToBackPage={goToBackPage}
      />
      <ContainRegister>
        <Row className={classes.containRegister}>
          <Col md={12} className={classes.headerRegister}>
            <img src={previewImage} className={classes.imgSpeaker} alt="" />
            <div className="event-info-container">
              <TitleRegister className="mx-4 mx-md-0 mb-4">
                {detailEvent?.aboutTitleEvent}
              </TitleRegister>
              <DateEvent>
                {detailEvent?.startDate} | {detailEvent?.startTime}
              </DateEvent>
              {isEventCompleted &&
                activeSave &&
                detailEvent.eventType === "Public" && (
                  <ButtonRegister
                    className="m-4 m-md-0"
                    onClick={() => saveRegister()}
                  >
                    {buttonRegister}
                  </ButtonRegister>
                )}
              {isEventCompleted && (
                <Row>
                  <Col md={5}>
                    {((activeSave && detailEvent.eventType === "Private") ||
                      (!activeCancel &&
                        detailEvent.eventType === "Private")) && (
                      <ButtonRegister
                        className="m-4 m-md-0"
                        onClick={() => saveAccept()}
                      >
                        {buttonAccept}
                      </ButtonRegister>
                    )}
                  </Col>
                  <Col md={6} hidden={!activeSave ? true : false}>
                    {activeSave && detailEvent.eventType === "Private" && (
                      <ButtonCancel
                        className="m-4 m-md-0"
                        onClick={() => saveDecline()}
                      >
                        {buttonDecline}
                      </ButtonCancel>
                    )}
                  </Col>
                </Row>
              )}
              {/*detailEvent?.endDate && 
            new Date(detailEvent.endDate) < new Date() 
             && validateUserAttendence() &&
            <RatingContainer>
                <label>Please rate this event!</label>
                <SizeImgRating>{arrayImageRating}</SizeImgRating> 
                </RatingContainer>*/}
              {(((activeCancel && detailEvent.eventType === "Public") ||
                (activeCancel && detailEvent.eventType === "Private")) && isEventCompleted) && (
                <ButtonCancel onClick={() => saveCancel()}>
                  {buttonCancel}
                </ButtonCancel>
              )}
              {}
            </div>
          </Col>
          <Row className={classes.containAbout}>
            <Col md={12} className={classes.headerDetailAbout}>
              <TitleAbout className="mb-2">
                {detailEvent?.aboutTitle}
              </TitleAbout>
              <div
                style={{
                  color: themeConfig.neutral.gray[2600],
                  fontSize: "1rem",
                }}
                dangerouslySetInnerHTML={{
                  __html: detailEvent?.aboutDescription,
                }}
              ></div>
            </Col>
          </Row>
          {detailEvent?.speakers?.length > 0 && (
            <TitleAbout style={{ marginLeft: "12px" }} className="mb-2">
              Speakers
            </TitleAbout>
          )}
          <Row>
            {detailEvent?.speakers &&
              detailEvent?.speakers.map((speaker, index) => {
                return (
                  <Col key={index} md={6} style={{ marginTop: "15px" }}>
                    <ListOfSpeakers
                      nameSpeaker={speaker?.idSpeakerNavigation?.label}
                      jobPositionSpeaker={
                        speaker?.idSpeakerNavigation?.position
                      }
                      websiteSpeaker={""}
                      photo={
                        speaker?.idSpeakerNavigation?.urlPhoto.match(
                          /\.(jpg|png|jpeg|gif|JPG|PNG|JPEG|GIF)$/
                        ) && speaker?.idSpeakerNavigation?.urlPhoto
                      }
                      buttonSpeaker={buttonSpeaker}
                      descriptionSpeaker={
                        speaker?.idSpeakerNavigation?.description
                      }
                      emailSpeaker={speaker?.idSpeakerNavigation?.email}
                      setOpenReadMoreModal={setOpenReadMoreModal}
                    />
                  </Col>
                );
              })}
          </Row>
        </Row>
        <HeaderDetail>
          <Row className="mb-4 heading-container">
            <Row className={classes.containItems}>
              <TitleOfDetail>Details</TitleOfDetail>
              <div>
                {detailEvent?.meetingLanguage === "English" && (
                  <ImgUsa src={UsaIcon} alt="" />
                )}{" "}
                {detailEvent?.meetingLanguage === "Español" && (
                  <ImgSpain src={SpainIcon} alt="" />
                )}{" "}
                {detailEvent?.meetingLanguage}
              </div>
            </Row>
          </Row>
          <Row className={classes.cardContainer}>
            <Col md="12" className={classes.cardDetailLeft}>
              <Row
                className={classes.containItemsFlex}
                style={{ fontWeight: "normal" }}
                hidden={
                  !detailEvent?.recurrenceEndDate ||
                  !detailEvent?.recurrencePattern
                }
              >
                <p>Recurren Event</p>
                {detailEvent?.recurrencePattern && (
                  <p>
                    Every{" "}
                    <span className="freq-text">
                      {detailEvent?.recurrencePattern.match(/FREQ=([^;]+)/)[1]}
                    </span>
                  </p>
                )}
                <p>
                  {detailEvent?.startTime} - {detailEvent?.endTime}
                </p>
                {detailEvent?.recurrenceEndDate ? (
                  <p className="until-text">
                    Until:{" "}
                    {moment(detailEvent?.recurrenceEndDate).format("MM DD/YY")}
                  </p>
                ) : (
                  <p>{"Until: Never"}</p>
                )}
              </Row>
              <Row
                className={classes.containItemsFlex}
                hidden={
                  detailEvent?.recurrenceEndDate ||
                  detailEvent?.recurrencePattern
                }
              >
                {detailEvent?.startDate} | {detailEvent?.startTime}
              </Row>
              <Row className={classes.containItems}>
                Speaker:{" "}
                <span style={{ fontWeight: "400", marginLeft: "2px" }}>
                  {detailEvent?.speakers &&
                    detailEvent?.speakers[0]?.idSpeakerNavigation?.label}{" "}
                  -{" "}
                  {detailEvent?.speakers &&
                    detailEvent?.speakers[0]?.idSpeakerNavigation?.position}
                </span>
              </Row>
              <Row className={classes.containItems}>
                Duration:{" "}
                <span style={{ fontWeight: "400", marginLeft: "2px" }}>
                  {detailEvent?.duration} hours
                </span>
              </Row>
              <Row className={classes.containItems}>
                Attendees:{" "}
                <span style={{ fontWeight: "400", marginLeft: "2px" }}>
                  {detailEvent?.attendees} people
                </span>
              </Row>
              {detailEvent?.idCategoryNavigation?.value === 1 && (
                <>
                  <Row
                    className={classes.containItemsFlex}
                    style={{ fontWeight: "normal" }}
                  >
                    {
                      detailEvent?.wellnessSearchGroupUsers[
                        detailEvent?.wellnessSearchGroupUsers.findIndex(
                          (item) => item.idUser === userComplete.userId
                        )
                      ]?.user?.firstName
                    }{" "}
                    {
                      detailEvent?.wellnessSearchGroupUsers[
                        detailEvent?.wellnessSearchGroupUsers.findIndex(
                          (item) => item.idUser === userComplete.userId
                        )
                      ]?.user?.lastName
                    }{" "}
                    {
                      detailEvent?.wellnessParticipants[
                        detailEvent?.wellnessParticipants.findIndex(
                          (item) => item.userId === userComplete.userId
                        )
                      ]?.attendStatus
                    }
                  </Row>
                  <Row
                    className={classes.containItemsFlex}
                    style={{ fontWeight: "normal" }}
                  >
                    {
                      detailEvent?.wellnessSearchGroupUsers[
                        detailEvent?.wellnessSearchGroupUsers.findIndex(
                          (item) => item.idUser !== userComplete.userId
                        )
                      ]?.user?.firstName
                    }{" "}
                    {
                      detailEvent?.wellnessSearchGroupUsers[
                        detailEvent?.wellnessSearchGroupUsers.findIndex(
                          (item) => item.idUser !== userComplete.userId
                        )
                      ]?.user?.lastName
                    }{" "}
                    (
                    {
                      detailEvent?.wellnessParticipants[
                        detailEvent?.wellnessParticipants.findIndex(
                          (item) => item.userId !== userComplete.userId
                        )
                      ]?.attendStatus
                    }
                    )
                  </Row>
                </>
              )}
            </Col>
            <Col md="12" className={classes.cardDetailRight}>
              <Row className={classes.containItemsFlex}>
                {detailEvent?.meetingDescription}
              </Row>
              {detailEvent?.meetingUrl && (
                <Row className={classes.containItemsFlex}>
                  <MeetingLink
                    className={"btn-link"}
                    href={`${detailEvent?.meetingUrl}`}
                    target="_new"
                  >
                    {detailEvent?.meetingUrl}
                  </MeetingLink>
                </Row>
              )}
            </Col>
          </Row>
        </HeaderDetail>
      </ContainRegister>

      <OtherEvent hidden={true}>
        <Row className={classes.containOtherEvent}>
          <Col md={12} className={classes.bodyOtherEvent}>
            <TitleOtherEvent className="mb-4">Other Events</TitleOtherEvent>
            <Row className={classes.rowContainOtherEvents}>
              {events?.events?.length > 0 &&
                events.events.map((event, index) => {
                  return (
                    <Col
                      key={event.idEvent}
                      md={6}
                      className={classes.colCardOtherEvent}
                    >
                      <ListCardEvents
                        eventTitle={event.eventTitle}
                        speakerName={event.speakerName}
                        jobPosition={event.jobPosition}
                        startDate={event.startDate}
                        startTime={event.startTime}
                        attendees={event.attendees}
                        language={event.language}
                        recurrenceEndDate={event.recurrenceEndDate}
                        recurrencePattern={event.recurrencePattern}
                      />
                    </Col>
                  );
                })}
            </Row>
          </Col>
        </Row>
      </OtherEvent>
      {showReadMoreModal()}
      {showFeedback && (
        <FeedbackComponent
          arrayImageRating={arrayImageRating}
          eventName={detailEvent?.aboutTitleEvent}
          handleSendFeedback={handleSendFeedback}
          eventRating={eventRating}
        />
      )}
    </>
  );
};

export default DetailEvent;
